export default __webpack_public_path__ + "static/media/undraw_bug_fixing_oc7a.fc64d2e6.svg";